/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { fetchAPI } from 'api';
import { URL_API } from 'api/index';

const ROTA = '/forms/pacotes';

export interface PacoteFilters {
  numeroPacote?: string;
  gerente?: string;
  municipio?: string;
  data?: string;
  page?: number;
  limit?: number;
}

export interface ResponsavelAPI {
  uuid: string;
  name: string;
}

export interface InstitutionAPI {
  uuid: string;
  name: string;
}

export interface PacoteAPI {
  uuid: string;
  pacote_nome: string;
  data_envio: string;
  responsavel: ResponsavelAPI;
  institution: InstitutionAPI;
}

export interface PacotesApiResponse {
  data: PacoteAPI[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const getPacoteFormulariosByUUID = async (uuid: string) => {
  const response = await fetchAPI(`${URL_API}${ROTA}/${uuid}`, 'GET', null);
  return response;
};

export const getPacoteFormulariosInstitutionByUUID = async (uuid: string) => {
  const response = await fetchAPI(
    `${URL_API}${ROTA}/institution/${uuid}`,
    'GET',
    null,
  );
  return response;
};

export const getFormularioSecretariaMunicipalAgriculturaByUUID = async (
  uuid: string,
) => {
  const response = await fetchAPI(
    `${URL_API}${ROTA}/secretaria_municipal_agricultura/${uuid}`,
    'GET',
    null,
  );
  return response;
};

export const updateFormularioSecretariaMunicipalAgriculturaByUUID = async (
  uuid: string,
  data: any,
) => {
  const response = await fetchAPI(
    `${URL_API}${ROTA}/secretaria_municipal_agricultura/${uuid}`,
    'PUT',
    data,
  );
  return response;
};

export const getFormularioCmdrsByUUID = async (
  uuid: string,
) => {
  const response = await fetchAPI(
    `${URL_API}${ROTA}/cmdrs/${uuid}`,
    'GET',
  );
  return response.dados;
};


export const updateFormularioCmdrsByUUID = async (
  uuid: string,
  data: any,
) => {
  const response = await fetchAPI(
    `${URL_API}${ROTA}/cmdrs/${uuid}`,
    'PUT',
    data,
  );
  return response;
};


export const getServicosPrestados = async (uuid: string) => {
  const response = await fetchAPI(
    `${URL_API}${ROTA}/secretaria_municipal_agricultura/servicos_prestados/${uuid}`,
    'GET',
    null,
  );
  return response;
};

export const getListaServicosPrestados = async () => {
  const response = await fetchAPI(
    `${URL_API}${ROTA}/secretaria_municipal_agricultura/servicos_prestados`,
    'GET',
    null,
  );
  return response;
};


export const getFormularioPoliticaMunicipalAgriculturaFamiliarByUUID = async (
  uuid: string,
) => {
  try {
    if (!uuid) throw new Error('UUID is required');

    const response = await fetchAPI(
      `${URL_API}${ROTA}/politica_municipal_agricultura_familiar/${uuid}`,
      'GET',
      null,
    );

    console.log('GET Response:', response);
    return response;
  } catch (error) {
    console.error('GET Error:', error);
    throw error;
  }
};

export const updateFormularioPoliticaMunicipalAgriculturaFamiliarByUUID =
  async (uuid: string, data: any) => {
    try {
      if (!uuid) throw new Error('UUID is required');

      console.log('PUT Request Data:', { uuid, data });

      const response = await fetchAPI(
        `${URL_API}${ROTA}/politica_municipal_agricultura_familiar/${uuid}`,
        'PUT',
        data,
      );

      console.log('PUT Response:', response);
      return response;
    } catch (error) {
      console.error('PUT Error:', error);
      throw error;
    }
  };

export const getFormularioAssentamento = async (uuid: string) => {
  const response = await fetchAPI(
    `${URL_API}${ROTA}/comunidades_rurais_e_tradicionais/${uuid}`,
    'GET',
    null,
  );
  console.log(response);
  return response;
};

export const updateFormularioAssentamento = async (uuid: string, data: any) => {
  const response = await fetchAPI(
    `${URL_API}${ROTA}/comunidades_rurais_e_tradicionais/${uuid}`,
    'PUT',
    data,
  );
  return response;
};
export const getPacotesFormularios = async (filters?: PacoteFilters) => {
  let url = `${URL_API}${ROTA}`;

  if (filters) {
    const queryParams = new URLSearchParams();

    if (filters.numeroPacote) {
      queryParams.append('numeroPacote', filters.numeroPacote);
    }
    if (filters.gerente) {
      queryParams.append('gerente', filters.gerente);
    }
    if (filters.municipio) {
      queryParams.append('municipio', filters.municipio);
    }
    if (filters.data) {
      queryParams.append('data', filters.data);
    }
    if (filters.page) {
      queryParams.append('page', filters.page.toString());
    }
    if (filters.limit) {
      queryParams.append('limit', filters.limit.toString());
    }

    if (queryParams.toString()) {
      url += `?${queryParams.toString()}`;
    }
  }

  const response = await fetchAPI(url, 'GET', null);
  return response;
}

export const enviarFormularios = async (uuid: string) => {
  const response = await fetchAPI(`${URL_API}${ROTA}/enviar/${uuid}`, 'POST', null);
  return response;
}

export const getMunicipalManagers = async () => {
  const response = await fetchAPI(`${URL_API}${ROTA}/municipal-managers`, 'GET', null);
  return response;
}

export const getFormularioSimByUUID = async (
  uuid: string,
) => {
  const response = await fetchAPI(
    `${URL_API}${ROTA}/sim/${uuid}`,
    'GET',
  );
  return response.dados;
};

export const updateFormularioSimByUUID = async (
  uuid: string,
  data: any,
) => {
  const response = await fetchAPI(
    `${URL_API}${ROTA}/sim/${uuid}`,
    'PUT',
    data,
  );
  return response;
};

